import SectionTitle from "../layout/SectionTitle";
import { FaAward, FaLeaf, FaTools, FaUsers, FaCogs, FaBuilding } from "react-icons/fa";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';

const getAvantages = (t) => [
  {
    icon: <FaAward className="text-socabeg-gold text-4xl mb-4" />,
    title: t('home.why.advantage1.title'),
    description: t('home.why.advantage1.description'),
  },
  {
    icon: <FaTools className="text-socabeg-gold text-4xl mb-4" />,
    title: t('home.why.advantage2.title'),
    description: t('home.why.advantage2.description'),
  },
  {
    icon: <FaLeaf className="text-socabeg-gold text-4xl mb-4" />,
    title: t('home.why.advantage3.title'),
    description: t('home.why.advantage3.description'),
  },
  {
    icon: <FaCogs className="text-socabeg-gold text-4xl mb-4" />,
    title: t('home.why.advantage4.title'),
    description: t('home.why.advantage4.description'),
  },
  {
    icon: <FaBuilding className="text-socabeg-gold text-4xl mb-4" />,
    title: t('home.why.advantage5.title'),
    description: t('home.why.advantage5.description'),
  },
  {
    icon: <FaUsers className="text-socabeg-gold text-4xl mb-4" />,
    title: t('home.why.advantage6.title'),
    description: t('home.why.advantage6.description'),
  },
];

export default function ChoisirSection() {
  const { t } = useTranslation();
  const avantages = getAvantages(t);
  const [sectionRef, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  return (
    <section className="py-8 bg-socabeg-gray-light" ref={sectionRef}>
      <motion.div 
        className="container mx-auto px-4"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.6 }}
      >
        <SectionTitle
          overline={t('home.why.title')}
          highlight={t('home.why.highlight')}
          showLogo={true}
        />

        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          {avantages.map((avantage, index) => (
            <motion.div
              key={index}
              className="p-8 bg-white rounded-md shadow-[0_0px_15px_rgba(0,86,163,0.12)] hover:shadow-[0_4px_20px_rgba(0,10,255,0.12)] border-2 border-transparent  transition-all duration-300 ease-in-out"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ y: -5 }}
            >
              {avantage.icon}
              <h3 className="text-xl font-bold text-socabeg-blue mb-4">{avantage.title}</h3>
              <p className="text-xs text-socabeg-dark-gray ">{avantage.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
}
